import { Box, Chip } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

import type { GridRenderCellParams } from '@mui/x-data-grid-pro'
import type { AttributeRow } from './Attributes'

const sx = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: getPxAsRem(8),
    alignItems: 'center',
    height: '100%',
    padding: getPxAsRem(8),
}

export function ChipCell({ value, row }: GridRenderCellParams<AttributeRow>) {
    if (Array.isArray(value) && value.length) {
        const chips = value
            .filter((val) => !!val.value)
            .map((val) => (
                <Chip size="small" key={val.value} label={val.value} />
            ))
        return <Box sx={sx}>{chips.length ? chips : '-'}</Box>
    } else if (row.freetext && value) {
        return (
            <Box sx={sx}>
                <Chip label={value} size="small" />
            </Box>
        )
    } else if (row.yearpicker && value) {
        const displayValue =
            value instanceof Date ? value.getFullYear().toString() : value
        return (
            <Box sx={sx}>
                <Chip label={displayValue} size="small" />
            </Box>
        )
    } else if (value?.value) {
        return (
            <Box sx={sx}>
                <Chip label={value?.value} size="small" />
            </Box>
        )
    }
    return <Box sx={{ ...sx, marginLeft: getPxAsRem(4) }}>-</Box>
}
